// React context that lets a report keep its loading banner up until every TinyMCE
// rich-text editor on the page has finished initializing. EqipRichTextEditor reports
// when it mounts and when it fires onInit; pages that don't provide this context get
// no-ops, so the editor stays usable everywhere it's already used.
import { createContext } from 'react';

const EditorLoadingContext = createContext(null);

export default EditorLoadingContext;
